var exports = {
  "CR": "CustomStatusModal.module__modalRoot___ZXZDTF",
  "_l": "CustomStatusModal.module__previewSection___ZXZDTF",
  "uG": "CustomStatusModal.module__statusInputWrapper___ZXZDTF",
  "Dq": "CustomStatusModal.module__characterCount___ZXZDTF",
  "DY": "CustomStatusModal.module__emojiTriggerButton___ZXZDTF",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___ZXZDTF",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___ZXZDTF",
  "J7": "CustomStatusModal.module__clearButtonIcon___ZXZDTF",
  "qr": "CustomStatusModal.module__footer___ZXZDTF",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___ZXZDTF",
  "uD": "CustomStatusModal.module__expirationLabel___ZXZDTF",
  "S2": "CustomStatusModal.module__expirationSelect___ZXZDTF",
};

module.exports = exports;
